import React, { Component } from 'react'

import styles from './UnorderedList.css'

import ListItem from '../ListItem'

class UnorderedList extends Component {
  render () {
    let {children, ...otherAttributes} = this.props

    return (
      <ul className={`hw-unordered-list ${styles.unordered_list}`} {...otherAttributes}>{children}</ul>
    )
  }
}

UnorderedList.propTypes = {
  children: (props, propName, componentName) => {
    const prop = props[propName]

    let error = null
    React.Children.forEach(prop, (child) => {
      if (child.type !== ListItem) {
        if (typeof child !== 'string' || !child.match(/^[\n\r\s]+$/)) { // Ignore whitespace beetween elements
          error = new Error(`'${componentName}' children should be of type 'ListItem', not ${typeof child}: ${JSON.stringify(child)}`)
        }
      }
    })

    return error
  }
}

export default UnorderedList



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/UnorderedList/index.js